import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { toast } from 'react-toastify';

import { EMPTY_FIELD_MESSAGE } from '../../constants/generals';
import { IHistory } from '../../interfaces';
import { submitPlantForm } from '../../services/plantService';
import { isFormEmpty } from '../../utils/generalUtils';
import { BasePage } from '../reusableComponents/BasePage';
import { PlantForm } from './PlantForm';

export interface IAddPlantFormProps {
    history: IHistory;
}

export class AddPlantFormImpl extends React.PureComponent<IAddPlantFormProps, {}> {
    constructor(props: IAddPlantFormProps) {
        super(props);
    }

    handlePlantFormSubmit = (values) => {
        if (isFormEmpty(values)) {
            toast.error(EMPTY_FIELD_MESSAGE, {
                position: toast.POSITION.TOP_CENTER,
                className: 'failed-toast'
            });
            return;
        }
        return submitPlantForm(values, this.props.history);
    }

    render() {
        return <BasePage key={3} pageTitle="Add Plant" >
            <PlantForm
                model="forms.plantForm"
                onSubmit={this.handlePlantFormSubmit}
            />
        </BasePage >;
    }
}

export function mapStateToProps() {
    return {
    };
}

export const AddPlantForm = withRouter(connect<{}, {}, IAddPlantFormProps>(mapStateToProps)(AddPlantFormImpl as any));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Maintenance/AddPlantForm.tsx